import { Patient, PatientQuery } from '@dreryk/egabinet-patient-frontend-api';
import { IdentityDocument } from '@dreryk/egabinet-patient-published-language-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { FullscreenSpinner, Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

type PassportIdentityDocumentValidModalLoaderResult = {
   identityDocument: IdentityDocument | undefined;
};

type PassportIdentityDocumentValidModalLoaderProps = {
   readonly children: (result: PassportIdentityDocumentValidModalLoaderResult) => JSX.Element;
   readonly patientId: number;
};

export const PassportIdentityDocumentValidModalLoader = (
   props: PassportIdentityDocumentValidModalLoaderProps
): JSX.Element | null => {
   const { data: patient, loading: patientLoading, error: patientError } = useCqrsGet<Patient>(() => {
      const query = new PatientQuery();
      query.id = Slot.of(props.patientId);
      return query;
   });

   if (patientLoading) {
      return <FullscreenSpinner />;
   }

   if (patientError) {
      return (
         <Message
            testId={'fetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({
      identityDocument: patient.identityDocument,
   });
};
